import React, {Component} from 'react';

import { MergeAttributes } from '../../FlatData';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

export default class SelectDepartmentGroup extends Component {
  constructor(props){
    super(props)

    this.onRowSelect = this.onRowSelect.bind(this);
  }

  onRowSelect(row, isSelected, e) {
    this.props.onChange(row);
  }

  render(){
    const options = {
      onRowClick: this.onRowSelect,
          sizePerPageList: []
      };
    var data = MergeAttributes(this.props.department_groups);
    
    return (
      <div>
        <BootstrapTable 
          data={data}
          search={ true }
          multiColumnSearch={ true }
          options={ options }
          striped
          hover
          condensed
          pagination
          version='4'
          tableContainerClass={'table-sm'}>
            <TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
            <TableHeaderColumn dataField='name' dataSort={ true }>กลุ่มสารบรรณ</TableHeaderColumn>
            <TableHeaderColumn dataField='member_names' dataSort={ true }>ผู้ดำเนินการ</TableHeaderColumn>
        </BootstrapTable>

        <div className="modal-footer row">
          <button type='button' className="btn btn-secondary pointer" onClick={()=>this.props.onClose()}>ยกเลิก</button>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/documents/elements/SelectDepartmentGroup.js